<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Create your account</h1>
        <p class="light">Enter your details below to create your account:</p>

        <form class="signup" _lpchecked="1">
          <div class="field">
            <div class="label">
              Your Name
            </div>
            <app-text-input
              icon="user"
              type="text"
              v-model="registrant.contact_name"
              placeholder="Enter your full name"
              :error="validation('contact_name')"
            />
          </div>
          <div class="field">
            <div class="label">
              Business
            </div>
            <app-text-input
              icon="industry"
              type="text"
              v-model="registrant.company"
              placeholder="Enter business name"
              :error="validation('company')"
            />
          </div>

          <div class="field">
            <div class="label">
              Email Address
            </div>
            <app-text-input
              icon="mail"
              type="text"
              v-model="registrant.email"
              placeholder="Enter your e-mail address"
              :error="validation('email')"
            />
          </div>

          <div class="field register-turnstile-field" v-if="turnstileSiteKey">
            <div
              ref="turnstileContainer"
              class="cf-turnstile register-turnstile"
              :data-sitekey="turnstileSiteKey"
              data-action="turnstile-spin-v2"
            ></div>
          </div>

          <div class="field">
            <p>By creating an account, you agree to our terms of service and to occasional marketing communications. Opt out anytime.</p>
            <a href="#" class="ui fluid primary button" v-bind:class="{ loading: submitting, disabled: submitting }" v-on:click.prevent="register">CREATE ACCOUNT</a>
          </div>
        </form>

        <hr>
        <p>Already have an account?
          <router-link :to="{name: 'Login'}"><a href="#" class="primary">Login Now</a></router-link>
        </p>
      </div>
    </div>
  </div>
</div>
